import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { SortType } from "../carLine/carLineApi";

export interface ItemProvider {
  providerId: number,
  providerTitle: string
}
export interface INetwork {
  id: number;
  image: string;
  title: string;
  numberharacters: number;
  expense: number;
  numberPrefixes: string;
  brandName: string
  typeZNSId: number
  typeZNSType: string
  status: number
  numberEmail: number
  integrationProviderList: ItemProvider[]
  providerId: number
  messageType?: string
}


//Danh sách network
export const getListNetwork = async (limit?: number, pageNumber?: number, type?: number) => {
  const path = "network/listNotificationCosts"
  const params = {
    limit, pageNumber, type
  }
  const result: ResponseSuccessTotal<INetwork[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin network
export const getInfoNetwork = async (
  id: number, type: number) => {
  const path = "network/infoNotificationCosts"
  const params = {
    id, type
  }
  const result: ResponseSuccessTotal<INetwork> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thêm mới chi phí thông báo
export const addNotificationCosts = async (
  expense: number, type: number, image?: File, title?: string, typeZNSId?: number, numberharacters?: number, numberEmail?: number, numberPrefix?: string[], providerId?: number[], messageType?: number
) => {
  const url = `network/addNotificationCosts`;
  const params = {
    expense, type, image, title, typeZNSId, numberharacters, numberEmail, numberPrefix, providerId, messageType
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}

//Chỉnh sửa chi phí thông báo
export const editNotificationCosts = async (
  id: number, expense: number, type: number, image?: File,
  title?: string, typeZNSId?: number, numberharacters?: number,
  numberEmail?: number, numberPrefix?: string[],
  providerId?: number[], messageType?: number
) => {
  const url = `network/editNotificationCosts`;
  const params = {
    id, expense, type, image,
    title, typeZNSId, numberharacters,
    numberEmail, numberPrefix,
    providerId, messageType
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

//Xóa network
export const deleteNetwork = async (
  id: Number
) => {
  const url = `network/deleteNetwork`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}


export const deleteNotificationCosts = async (
  id: Number
) => {
  const url = `network/deleteNotificationCosts`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}
